// The job page's "Photos": the job's Photo - Before folder on SharePoint, a
// folder per area, opened in a new tab. SharePoint is the one copy of the
// photos (DD, 2026-10-19); it replaced Site2Scope's photos ZIP, from when that
// app had no SharePoint to save to.
import { Images } from 'lucide-react';
import { photoFolderUrl, photoLinks } from '../lib/area-photos';
import type { DeviceRecord } from '../lib/device-db';
import { useOnline } from '../lib/hooks';
import { HeaderOutboundLink } from './header-outbound-link';

/** Why the folder can't be opened right now; null = it can. */
function blockedBecause(url: string | null, online: boolean): string | null {
  if (!online) return 'Opening the photos needs signal.';
  if (!url) return 'No photos have uploaded to SharePoint yet.';
  return null;
}

/** `records`: the job's, for its photo rows and its areas' older photo lists. */
export function PhotosFolderLink({ records }: { records: readonly DeviceRecord[] }) {
  const online = useOnline();
  const url = photoFolderUrl(photoLinks(records));
  const blocked = blockedBecause(url, online);
  return (
    <HeaderOutboundLink href={url} blocked={blocked} title="The job's photos on SharePoint, a folder per area">
      <Images className="h-4 w-4" /> Photos
    </HeaderOutboundLink>
  );
}
